const data = [
  {
    course: "aqeedah",
    name: "সহীহ আক্বীদাহ",
    upcomingBatch: 29,
    admissionStartDate: "1 Oct 2026",
    admissionEndDate: "30 Oct 2026",
    orientationDate: "1 Nov 2026",
    flexibleAdmissionDate: "10 Nov 2026",
    duration: "৭.৫ মাস",
    teacher: "শায়খ আব্দুল্লাহ আল বাকি (হাফি.)",
    theme: ["from-blue-400", "to-sky-300"],
  },

  {
    course: "fiqh",
    name: "সহজ ইসলামী ফিকহ",
    duration: "৬ মাস",
    teacher: "শায়খ আব্দুল্লাহ আল কাফী (রহি.)",
    upcomingBatch: 12,
    admissionStartDate: "1 Oct 2026",
    admissionEndDate: "15 Oct 2026",
    orientationDate: "18 Oct 2026",
    flexibleAdmissionDate: "25 Oct 2026",
    theme: ["from-teal-500", "to-cyan-200"],
  },

  {
    course: "seerat",
    name: "সীরাতুন নবী (সাঃ)",
    duration: "৩ মাস",
    teacher: "শায়খ আব্দুল্লাহ আল কাফী (রহি.)",
    upcomingBatch: 7,
    admissionStartDate: "10 Oct 2026",
    admissionEndDate: "5 Nov 2026",
    orientationDate: "7 Nov 2026",
    flexibleAdmissionDate: "15 Nov 2026",
    theme: ["from-fuchsia-400", "to-sky-200"],
  },

  {
    course: "tajweed",
    name: "সহজ তাজউইদ",
    duration: "১ বছর ৩ মাস",
    teacher: "উস্তাদা শামসুন্নাহার",
    badge: "শুধুমাত্র মহিলাদের জন্য",
    badge_cls: "bg-pink-300",
    upcomingBatch: 5,
    admissionStartDate: "1 Nov 2026",
    admissionEndDate: "28 Nov 2026",
    orientationDate: "1 Dec 2026",
    flexibleAdmissionDate: "8 Dec 2026",
    theme: ["from-red-400", "to-red-300"],
  },
  {
    course: "tafseer",
    name: "সংক্ষিপ্ত তাফসীর",
    duration: "৩ মাস",
    teacher: "শায়খ আব্দুল্লাহ আল কাফী (রহি.)",
    upcomingBatch: 7,
    admissionStartDate: "5 Nov 2026",
    admissionEndDate: "20 Nov 2026",
    orientationDate: "22 Nov 2026",
    flexibleAdmissionDate: "30 Nov 2026",
    theme: ["from-slate-400", "to-slate-300"],
  },

  {
    course: "arabic",
    name: "সহজ আরবি ভাষা",
    duration: "২ বছর",
    teacher: "ফাইসাল আব্দুল্লাহ",
    upcomingBatch: 6,
    admissionStartDate: "1 Oct 2026",
    admissionEndDate: "25 Oct 2026",
    orientationDate: "27 Oct 2026",
    flexibleAdmissionDate: "5 Nov 2026",
    theme: ["from-green-400", "to-green-300"],
  },

  {
    course: "asmaul-husna",
    name: "আল আসমাউল হুসনা",
    duration: "১ মাস",
    teacher: "ফাইসাল আব্দুল্লাহ",
    upcomingBatch: 3,
    admissionStartDate: "1 Dec 2026",
    admissionEndDate: "15 Dec 2026",
    orientationDate: "20 Dec 2026",
    flexibleAdmissionDate: "30 Dec 2026",
    theme: ["from-green-400", "to-sky-400"],
  },

  {
    course: "ramadan-siyam",
    name: "রমাদান ও সিয়াম",
    duration: "১ মাস",
    teacher: "শায়খ আব্দুল্লাহ আল বাকি (হাফি.)",
    badge: "রমাদান স্পেশাল কোর্স",
    badge_cls: "badge-warning",
    upcomingBatch: 6,
    admissionStartDate: "1 Jan 2027",
    admissionEndDate: "25 Jan 2027",
    orientationDate: "1 Feb 2027",
    flexibleAdmissionDate: "11 Feb 2027",
    theme: ["from-orange-300", "to-red-300"],
  },
  {
    course: "dua",
    name: "দোআ ও যিকির",
    duration: "২৫ দিন",
    teacher: "ফাইসাল আব্দুল্লাহ",
    badge: "রমাদান স্পেশাল কোর্স",
    badge_cls: "badge-warning",
    upcomingBatch: 5,
    admissionStartDate: "15 Jan 2027",
    admissionEndDate: "5 Feb 2027",
    orientationDate: "6 Feb 2027",
    flexibleAdmissionDate: "16 Feb 2027",
    theme: ["from-red-300", "to-yellow-300"],
  },
];

function getCourseData() {
  return data;
}

export { getCourseData };
